module.exports = __webpack_public_path__ + "static/media/p16.371a9b74.png";